<div id="app" class="app" [dir]="(settings.rtl) ? 'rtl' : 'ltr'" [ngClass]="settings.theme" 
    [class.homolog]="isHomolog" [class.fixed-header]="settings.fixedHeader" [class.fixed-sidenav]="settings.fixedSidenav"
    [class.fixed-footer]="settings.fixedFooter" [class.horizontal-menu]="settings.menu == 'horizontal'"
    [class.compact]="settings.menuType == 'compact'" [class.mini]="settings.menuType == 'mini'">
    <router-outlet></router-outlet>
    <div id="app-spinner" [class.hide]="!settings.loadingSpinner">
        <div class="app-spinner-logo">
            <svg width="64" height="64" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="38" rx="9" fill="#1D2D42"/>
                <path d="M11 8 C11 14 19 17 19 19 C19 21 11 24 11 30"
                      stroke="#F0802A" stroke-width="3" stroke-linecap="round"/>
                <path d="M27 8 C27 14 19 17 19 19 C19 21 27 24 27 30"
                      stroke="#FFB37B" stroke-width="3" stroke-linecap="round"/>
            </svg>
        </div>
        <h4>Aguarde um momento, por favor...</h4>
    </div>
</div>